<template>
  <div :data-widget-title="content.title.text" class="mask-wave-t my-10">
    <div
      class="px-8 py-10"
      :class="content.backgroundColor === 'white' ? 'bg-white lg:py-24 lg:mb-12' : 'bg-gray-50'"
    >
      <div class="max-w-screen-xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-x-16 xl:gap-x-32">
        <SliceTitle class="title lg:col-span-full xl:col-span-1" :value="content.title" />

        <div class="lg:col-start-2 xl:row-start-1 xl:row-span-2">
          <picture
            class="rounded-10 overflow-hidden block mx-auto max-w-screen-sm lg:max-w-full relative"
            :class="{ 'shadow-4': content.imageShadow }"
          >
            <ImageCopyright
              v-if="content.image?.copyright"
              class="rounded-tl-10"
              :copyright="content.image.copyright"
            />
            <source
              v-if="mobileImageSrc"
              media="(max-width: 767px)"
              :srcset="mobileImageSrc.join(',')"
            />
            <img
              v-if="imageSrcset && imageSrc"
              class="w-full"
              :loading="isChromatic ? undefined : 'lazy'"
              :src="imageSrc"
              :srcset="imageSrcset.join(',')"
              :alt="content.image.alt ?? ''"
            />
          </picture>
        </div>

        <div class="lg:col-start-1 lg:row-start-2">
          <PortableText :content="content.content" class="typography" />
          <a
            v-if="content.optionalCta"
            class="btn btn-amber mt-6"
            :href="content.optionalCta.link ?? undefined"
          >
            {{ content.optionalCta.label }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GQLTextImageSlice } from './generated/text-image'

const props = defineProps<{ content: GQLTextImageSlice }>()

const imageSrcset = computed(() => {
  return getSrcset(props.content.image)
})
const imageSrc = computed(() => imageSrcset.value?.[0].split(' ')[0])

const mobileImageSrc = computed(() => {
  if (props.content.optionalMobileImage) {
    return getSrcset(props.content.optionalMobileImage)
  }
  return null
})
</script>
